<template>
    <div class="flow-wrap">
        <div class="info-tab">
            <div class="info-wrap">
                <div class="title">
                    <div class="name">{{ infoData.process_name || '暂无信息' }}</div>
                    <div class="num">{{ infoData.wokor_name || '暂无信息' }}</div>
                </div>
                <div class="date">整改截止时间：{{ infoData.new_rectifydeadline || '暂无信息' }}</div>
                <div class="date">整改完成时间：{{ infoData.new_completetime || '暂无信息' }}</div>
                <img class="state-img" v-if="infoData.new_status == 91" src="@/assets/images/archives/qualified.png"
                    alt="">
                <img class="state-img" v-if="infoData.new_status == 92" src="@/assets/images/archives/unqualified.png"
                    alt="">
                <img class="state-img" v-if="infoData.new_status == 93" src="@/assets/images/archives/modifying.png"
                    alt="">
                <img class="state-img" v-if="infoData.new_status == 94" src="@/assets/images/archives/modified.png"
                    alt="">
            </div>
            <div class="tab-wrap">
                <template v-for="(item, index) in arrTab">
                    <div class="tab-item" :class="{ 'tab-item-active': item.key == sTabCurrentKey }"
                        @click="tabChange(item.key)">{{ item.name }}</div>
                </template>
            </div>
        </div>
        <div class="content-info">
            <transition-group name="hello" appear>
                <div class="tab-content" v-show="sTabCurrentKey == 'basic'" key="basic">
                    <div class="basic-content">
                        <template v-for="item in objData">
                            <div class="item">
                                <div class="title-wrap">
                                    <div class="title">{{ item.title }}</div>
                                </div>
                                <div class="data-wrap">
                                    <template v-for="(it, itx) in item.content">
                                        <div class="lable-wrap" :style="{ 'background': (itx % 2) ? '#ffffff' : '#F9F9FB' }">
                                            <div class="lable">{{ it.label }}：</div>
                                            <div class="value">{{ it.value === '' ? '暂无内容' : it.value }}</div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="tab-content" v-show="sTabCurrentKey == 'progress'" key="progress">
                    <div class="reform-info">
                        <div class="reform-desc">你有<span>{{infoData.rectify_num || 0}}个</span>待整改项，若不整改，至少扣除100元/项结算费用</div>
                        <div class="remarks" v-if="infoData.rectify_remark">
                            <span>监理备注：</span>{{infoData.rectify_remark}}
                        </div>
                    </div>
                    <div class="supervision-content" v-if="objData != null">
                        <template v-for="item in objData">
                            <div class="item">
                                <div class="step-wrap">
                                    <div class="step-item">
                                        <div class="title-wrap">
                                            <div class="title">{{ item.title }}</div>
                                        </div>
                                        <template v-for="it in item.content">
                                            <div class="desc">*{{ it.title }}</div>
                                            <template v-if="it.photos && it.photos.length">
                                                <div class="live">
                                                    <template v-for="(img,imgindex) in it.photos">
                                                        <div class="live-img" @click="getShow(it.photos,imgindex)">
                                                            <img :src="img" alt="">
                                                        </div>
                                                    </template>
                                                </div>
                                                <div class="line"></div>
                                            </template>
                                            <template v-if="it.acceptance && it.acceptance.length">
                                                <div class="question">
                                                    <template v-for="qIt in it.acceptance">
                                                        <div class="question-item" v-if="qIt.checked != 0&&qIt.options.length">
                                                            <div class="title">{{ qIt.title }}</div>
                                                            <div class="answer-wrap">
                                                                <template v-for="an in qIt.options">
                                                                    <p
                                                                        :class="{ 'active-p': qIt.checked == an.option_val }">
                                                                        <span>{{ an.option_name }}</span>
                                                                        <img v-if="qIt.checked == an.option_val"
                                                                            src="@/assets/images/archives/workOrder/Group.png"
                                                                            alt="">
                                                                    </p>
                                                                </template>
                                                            </div>
                                                        </div>
                                                        <div class="question-item" v-if="qIt.checked == 0&&!qIt.options.length&&qIt.result != ''">
                                                            <div class="title">{{ qIt.title }}</div>
                                                            <div class="answer-wrap">
                                                                <p class="active-p">
                                                                    <span>{{ qIt.result }}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <template v-if="qIt.other && qIt.other.length && qIt.checked != 0">
                                                            <template v-for="rectitem in qIt.other">
                                                                <div :class="['rectify_item', 'pink']" v-if="rectitem.value">
                                                                    {{ rectitem.label || '' }}：<span>{{ rectitem.value ||
                                                                            ''
                                                                    }}</span>
                                                                </div>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </div>
                                            </template>
                                            <template v-if="it.rectify_photos && it.rectify_photos.length">
                                                <div class="desc blue">整改后照片</div>
                                                <div class="live">
                                                    <template v-for="(img,imgindex) in it.rectify_photos">
                                                        <div class="live-img" @click="getShow(it.rectify_photos,imgindex)">
                                                            <img :src="img" alt="">
                                                        </div>
                                                    </template>
                                                </div>
                                                <div class="line"></div>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="tab-content" v-show="sTabCurrentKey == 'attendance'" key="attendance">
                    <div class="attendance-content" v-if="objData != null">
                        <div class="title-wrap">
                            <div class="title">审批记录</div>
                        </div>
                        <div class="record-wrap">
                            <template v-for="(item, index) in objData.content">
                                <div class="record-item">
                                    <div class="record-day">
                                        <div class="day-top">
                                            <div class="day-left">
                                                <img src="@/assets/images/archives/workOrder/time-icon.png" alt="">
                                            </div>
                                            <div class="day-right">{{ item.date }}</div>
                                        </div>
                                        <div class="day-bottom">
                                            <p></p>
                                        </div>
                                    </div>
                                    <template v-for="(it, itx) in item.content">
                                        <div class="resord-date">
                                            <div class="date-top">
                                                <div class="date-left">{{ it.time }}</div>
                                                <div class="date-right">{{ it.content.title }}</div>
                                            </div>
                                            <div class="date-bottom">
                                                <div class="line-left">
                                                    <p
                                                        v-if="!((index == objData.content.length - 1) && (itx == item.content.length - 1))">
                                                    </p>
                                                </div>
                                                <div class="text">
                                                    <div class="text-content">{{ it.content.address }}</div>
                                                    <!-- <div class="img-wrap">
                                                        <template v-for="img in it.img">
                                                            <div class="img-item"></div>
                                                        </template>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="tab-content" v-show="sTabCurrentKey == 'approval'" key="approval">
                    <template v-if="objData != null">
                        <template v-for="(item, index) in objData">
                            <div class="attendance-content" v-if="item.type == 'step'">
                                <div class="title-wrap">
                                    <div class="title">{{ item.title }}</div>
                                </div>
                                <div class="step_list" v-if="item.content.length">
                                    <div v-for="(item2,index2) in item.content" :key="index2" class="step_item">
                                        <img class="step_icon" src="~@/assets/images/archives/dossier/time_icon.png" alt="">
                                        <div class="step_info">
                                            <div class="step_name flex jusb aic">
                                                <p>{{ item2.new_name }}</p>
                                                <p>{{ item2.new_status_text || '--' }}</p>
                                            </div>
                                            <div class="step_state flex jusb aic">
                                                <p>{{ item2.username }}</p>
                                                <p>{{ item2.new_approvedate }}</p>
                                            </div>
                                        </div>
                                        <div v-if="item2.new_result" class="step_msg">{{ item2.new_result }}</div>
                                    </div>
                                    <!-- <div class="them_box">
                                        知会人：<span>{{ item.them || '暂无' }}</span>
                                    </div> -->
                                </div>
                                <div v-if="!item.content.length" class="list_error">暂无信息</div>
                            </div>
                            <div class="attendance-content" v-if="item.type == 'timeline'">
                                <div class="title-wrap">
                                    <div class="title">{{ item.title }}</div>
                                </div>
                                <div class="record-wrap" v-if="item.content.length">
                                    <template v-for="(ite, inx) in item.content">
                                        <div class="record-item">
                                            <div class="record-day">
                                                <div class="day-top">
                                                    <div class="day-left">
                                                        <img src="@/assets/images/archives/workOrder/time-icon.png"
                                                            alt="">
                                                    </div>
                                                    <div class="day-right">{{ ite.date }}</div>
                                                </div>
                                                <div class="day-bottom">
                                                    <p></p>
                                                </div>
                                            </div>
                                            <template v-for="(it, itx) in ite.content">
                                                <div class="resord-date">
                                                    <div class="date-top">
                                                        <div class="date-left-two">{{ it.time }}</div>
                                                        <div class="date-right-two">
                                                            {{ it.content.new_name ? it.content.new_name : it.content.new_memo }}
                                                        </div>
                                                    </div>
                                                    <div class="date-bottom">
                                                        <div class="line-left">
                                                            <p
                                                                v-if="!((index == item.content.length - 1) && (itx == ite.content.length - 1))">
                                                            </p>
                                                        </div>
                                                        <div class="text">
                                                            <div class="text-info">
                                                                <div class="text-content-name">
                                                                    {{ it.content.new_username }}</div>
                                                                <div :class="['text-typetext', it.content.new_approvalstatus < 4 ? 'green' : 'red']"
                                                                    v-html="it.content.new_curr_approvestep_name"></div>
                                                            </div>
                                                            <!-- <div class="text-reason" v-if="it.type == 0">{{it.reason}}</div> -->
                                                            <!-- <div class="img-wrap" v-if="it.type == 0">
                                                                <template v-for="img in it.img">
                                                                    <div class="img-item"></div>
                                                                </template>
                                                            </div> -->
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </div>
                                <div v-if="!item.content.length" class="list_error">暂无信息</div>
                            </div>
                        </template>
                    </template>
                </div>
            </transition-group>
        </div>
        <!-- 预览图片 -->
        <van-image-preview v-model="imgShow" :closeable="true" :startPosition="lookImgIndex" :images="arrStausImg"></van-image-preview>
    </div>
</template>
<script>
import { getWorkorderRectify, getWorkorderInfo } from "@/js/archives/construction.js";
export default {
    data() {
        return {
            sTabCurrentKey: 'basic',
            infoData: {},
            lookImgIndex:0,
            objData: null,
            imgShow: false,
            arrStausImg:[],
            arrTab: [
                { name: '基本信息', key: 'basic' },
                { name: '过程反馈', key: 'progress' },
                { name: '考勤记录', key: 'attendance' },
                { name: '审核进度', key: 'approval' }
            ],
        }
    },
    created() {
        let _that = this;
        $init(() => {
            _that.$store.commit("loadSwitch", true);
            Promise.all([_that.getWorkorderRectify(), _that.getWorkorderInfo()]).then(res => {
                _that.$store.commit("loadSwitch", false);
            })
        })
    },
    methods: {
        getShow(e,num) {
            this.lookImgIndex = num;
            this.imgShow = true;
            this.arrStausImg = e;
        },
        getWorkorderInfo() {
            return new Promise((resolve, reject) => {
                let _that = this;
                getWorkorderInfo({ workorder_id: _that.$route.query.workorderId }).then(res => {
                    resolve()
                    if (res.data.error == 0) {
                        let infoData = res.data.data.result;
                        _that.infoData = infoData
                    } else {
                        _that.$toast(res.data.msg);
                    }
                })
            })
        },
        getWorkorderRectify(bLoading = false) {
            return new Promise((resolve, reject) => {
                let _that = this;
                if (bLoading) {
                    _that.$store.commit("loadSwitch", true);
                }
                getWorkorderRectify({ workorder_id: _that.$route.query.workorderId, tab: _that.sTabCurrentKey }).then(res => {
                    resolve()
                    if (res.data.error == 0) {
                        let objData = res.data.data.result;
                        _that.objData = objData
                    } else {
                        _that.$toast(res.data.msg);
                    }
                    if (bLoading) {
                        _that.$store.commit("loadSwitch", false);
                    }
                })
            })
        },
        // 切换标签
        tabChange(key) {
            this.objData = null;
            this.sTabCurrentKey = key;
            this.getWorkorderRectify(true);
        },
    }
}
</script>
<style lang="scss" scoped>
.flex {
    display: flex;
}

.aic {
    align-items: center;
}

.ais {
    align-items: flex-start;
}

.aie {
    align-items: flex-end;
}

.juc {
    justify-content: center;
}

.jue {
    justify-content: flex-end;
}

.jusb {
    justify-content: space-between;
}

.fw {
    flex-wrap: wrap;
}

.fnw {
    flex-wrap: nowrap;
}
::-webkit-scrollbar {
    display: none
}

/* 进入的起点、离开的终点 */
.hello-enter,
.hello-leave-to {
    opacity: 0;
    transform: translateX(-100%);
}

.hello-enter-active,
.hello-leave-active {
    transition: 0.4s linear;
}

/* 进入的终点、离开的起点 */
.hello-enter-to,
.hello-leave {
    opacity: 1;
    transform: translateX(0);
}

.flow-wrap {
    width: 100vw;
    height: 100vh;
    background: #F9F9FB;
    display: flex;
    flex-direction: column;

    .info-tab {
        padding: 38px 32px 16px 32px;
        //margin-bottom: 16px;
        background: #F3F6FF;

        .info-wrap {
            position: relative;

            .title {
                display: flex;
                align-items: center;

                .name {
                    font-size: 36px;
                    font-weight: 600;
                    color: #333333;
                    line-height: 42px;
                }

                .num {
                    font-size: 24px;
                    font-weight: 400;
                    color: #555555;
                    line-height: 28px;
                    margin-left: 16px;
                }

            }

            .date {
                font-size: 24px;
                font-weight: 400;
                color: #555555;
                margin-top: 16px;
                line-height: 28px;
            }

            .state-img {
                position: absolute;
                top: 0px;
                right: 0px;
                width: 161px;
                height: 153px;
            }
        }

        .tab-wrap {
            width: 100%;
            height: 80px;
            background: #FFFFFF;
            border-radius: 16px 16px 16px 16px;
            margin-top: 84px;
            display: flex;
            padding: 0 88px;
            justify-content: space-between;

            .tab-item {
                font-size: 24px;
                font-weight: 400;
                color: #A3A3A3;
                line-height: 80px;
            }

            .tab-item-active {
                font-weight: 600;
                color: #0D53FC;
                position: relative;

                &:after {
                    width: 100%;
                    height: 4px;
                    content: '';
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    background: #0D53FC;
                }
            }
        }
    }

    .content-info {
        width: 100%;
        flex: 1;
        padding: 0px 32px 32px 32px;
        overflow-y: scroll;
        background: linear-gradient(to bottom, #F3F6FF 0%, #F3F6FF 10%, #F9F9FB 10.01%, #F9F9FB 100%);

        .tab-content {
            width: 100%;

            .reform-info {
                padding: 48px;
                box-sizing: border-box;
                background: #fff;
                margin-bottom: 16px;
                border-radius: 16px 16px 16px 16px;

                .reform-desc {
                    font-size: 24px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 32px;

                    span {
                        color: #000;
                    }
                }

                .remarks {
                    font-size: 24px;
                    font-weight: 400;
                    line-height: 28px;
                    color: #FF0000;
                    margin-top: 48px;

                    span {
                        color: #000;
                    }
                }
            }

            .basic-content {
                width: 100%;

                .item {
                    margin-bottom: 16px;
                    width: 100%;
                    background: #FFFFFF;
                    border-radius: 16px 16px 16px 16px;
                    overflow: hidden;

                    .title-wrap {
                        padding: 32px 44px;

                        .title {
                            font-size: 24px;
                            font-weight: 500;
                            color: #333333;
                            line-height: 28px;
                            border-left: 5px solid #0D53FC;
                            padding-left: 16px;
                        }
                    }

                    .data-wrap {
                        .lable-wrap {
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;
                            height: 80px;
                            background: #F9F9FB;
                            padding: 0 48px;

                            .lable {
                                font-size: 24px;
                                color: #999999;
                            }

                            .value {
                                font-size: 24px;
                                font-weight: 500;
                                color: #333333;
                            }
                        }
                    }
                }
            }

            .supervision-content {
                .item {
                    width: 100%;
                    border-radius: 16px;
                    background: #ffffff;
                    padding: 32px 44px;
                    margin-bottom: 16px;

                    .title {
                        font-size: 28px;
                        font-weight: 600;
                        color: #333333;
                        line-height: 33px;
                    }

                    .step-wrap {
                        .step-item {
                            padding-bottom: 64px;
                            border-bottom: 2px solid #F5F5F5;
                            margin-bottom: 48px;

                            &:last-child {
                                margin-bottom: 0;
                                border-bottom: 0;
                                padding-bottom: 0;
                            }

                            .title-wrap {
                                .title {
                                    font-size: 24px;
                                    color: #333333;
                                    line-height: 28px;
                                    border-left: 5px solid #0D53FC;
                                    padding-left: 16px;
                                }
                            }

                            .desc {
                                font-size: 24px;
                                font-weight: 400;
                                color: #999999;
                                line-height: 40px;
                                margin: 20px 0 16px 0;
                            }

                            .blue{
                                color: #0D53FC;
                            }

                            .tips {
                                font-size: 20px;
                                font-weight: 500;
                                color: #E95859;
                                line-height: 23px;
                                text-indent: 10px;
                            }

                            .standard {
                                background: #F9F9FB;
                                border-radius: 16px;
                                overflow: hidden;
                                margin-top: 32px;

                                .title {
                                    width: 100%;
                                    height: 64px;
                                    background: linear-gradient(126deg, rgba(13, 83, 252, 0.5) 0%, rgba(13, 83, 252, 0) 100%);
                                    padding-left: 20px;
                                    line-height: 64px;
                                    font-size: 24px;
                                    font-weight: 500;
                                    color: #FFFFFF;
                                }

                                .img-wrap {
                                    overflow: hidden;
                                    width: 100%;
                                    height: 274px;
                                    background: #F9F9FB;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;

                                    img {
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    }
                                }
                            }

                            .live {
                                overflow-x: scroll;
                                margin-top: 16px;
                                white-space: nowrap;

                                .live-img {
                                    display: inline-block;
                                    width: 160px;
                                    height: 160px;
                                    background: #F9F9FB;
                                    border-radius: 16px;
                                    margin-right: 16px;

                                    img {
                                        width: 100%;
                                        height: 100%;
                                        object-fit: cover;
                                    }
                                }
                            }

                            .line {
                                margin: 30px 0;
                                border: 2px solid #F5F5F5;
                            }

                            .question {
                                .rectify_item {
                                    width: 100%;
                                    height: 74px;
                                    border-radius: 16px 16px 16px 16px;
                                    display: flex;
                                    align-items: center;
                                    padding: 0 40px;
                                    box-sizing: border-box;
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: #000000;
                                    line-height: 28px;
                                    margin-bottom: 14px;

                                    span {
                                        font-size: 24px;
                                        font-weight: 400;
                                        color: #999999;
                                    }
                                }

                                .rectify_item.pink {
                                    background: rgba($color: #E95859, $alpha: 0.1);
                                }

                                .rectify_item.grey {
                                    background: rgba($color: #F9F9FB, $alpha: 1.0);
                                }

                                .question-item {
                                    margin-top: 70px;
                                    margin-bottom: 32px;

                                    &:last-child {
                                        margin-bottom: 0;
                                    }
                                    &:first-child {
                                        margin-top: 0;
                                    }

                                    .title {
                                        font-size: 24px;
                                        font-weight: 400;
                                        color: #999999;
                                        margin-bottom: 22px;
                                        line-height: 28px;
                                    }

                                    .answer-wrap {
                                        display: flex;

                                        p {
                                            width: 30%;
                                            font-size: 24px;
                                            font-weight: 400;
                                            color: #999999;
                                            line-height: 28px;
                                            display: flex;
                                            align-items: center;

                                            img {
                                                width: 32px;
                                                height: 32px;
                                            }
                                        }

                                        .active-p {
                                            color: #000000;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .worker-content {
                .item {
                    width: 100%;
                    height: 338px;
                    background: #FFFFFF;
                    border-radius: 16px;
                    padding: 32px 44px;
                    margin-bottom: 16px;

                    .title-wrap {
                        .title {
                            font-size: 24px;
                            font-weight: 500;
                            color: #333333;
                            line-height: 28px;
                            border-left: 5px solid #0D53FC;
                            padding-left: 16px;
                        }

                        .live {
                            margin-top: 48px;
                            overflow-x: scroll;
                            white-space: nowrap;

                            .live-img {
                                display: inline-block;
                                width: 160px;
                                height: 160px;
                                background: #F9F9FB;
                                border-radius: 16px;
                                margin-right: 16px;

                                img {
                                    width: 100%;
                                    height: 100%;
                                    object-fit: cover;
                                }
                            }
                        }
                    }
                }
            }

            .attendance-content {
                width: 100%;
                background: #FFFFFF;
                border-radius: 16px;
                padding: 32px 44px;
                margin-bottom: 16px;

                .title-wrap {
                    margin-bottom: 66px;

                    .title {
                        font-size: 24px;
                        font-weight: 500;
                        color: #333333;
                        line-height: 28px;
                        border-left: 5px solid #0D53FC;
                        padding-left: 16px;
                    }
                }

                .list_error {
                    padding-bottom: 66px;
                    box-sizing: border-box;
                    text-align: center;
                    font-size: 28px;
                    font-weight: 400;
                    color: #999999;
                    line-height: 33px;
                }

                .record-wrap {
                    .record-item {
                        .record-day {
                            .day-top {
                                display: flex;
                                align-items: center;

                                .day-left {
                                    width: 64px;

                                    img {
                                        width: 64px;
                                        height: 64px;
                                    }
                                }

                                .day-right {
                                    padding-left: 30px;
                                    font-size: 28px;
                                    font-weight: 600;
                                    color: #333333;
                                }
                            }

                            .day-bottom {
                                width: 64px;
                                height: 80px;
                                display: flex;
                                align-items: center;
                                justify-content: center;

                                p {
                                    width: 0px;
                                    height: 100%;
                                    border-left: 2px dashed #EEEEEE;
                                }
                            }
                        }

                        .resord-date {
                            .date-top {
                                display: flex;

                                // align-items: center;
                                .date-left {
                                    width: 64px;
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: #000;
                                }

                                .date-right {
                                    padding-left: 30px;
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: #000;
                                }

                                .date-left-two {
                                    width: 64px;
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: #999999;
                                }

                                .date-right-two {
                                    padding-left: 30px;
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: #999999;
                                }
                            }

                            .date-bottom {
                                display: flex;

                                .line-left {
                                    width: 64px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;

                                    p {
                                        width: 0px;
                                        height: 100%;
                                        border-left: 1px dashed #EEEEEE;
                                    }
                                }

                                .text {
                                    flex: 1;
                                    font-size: 24px;
                                    font-weight: 400;
                                    padding-left: 30px;
                                    color: #999999;
                                    padding-bottom: 50px;

                                    .text-info {
                                        margin-top: 8px;
                                        display: flex;
                                        justify-content: space-between;
                                    }

                                    .text-reason {
                                        font-size: 24px;
                                        font-weight: 500;
                                        color: #EA5F56;
                                        line-height: 40px;
                                        text-align: justify;
                                        margin-top: 16px;
                                    }

                                    .text-typetext {
                                        font-size: 24px;
                                        font-weight: 400;
                                        line-height: 28px;
                                    }

                                    .text-typetext.red {
                                        color: #EA5F56;
                                    }

                                    .text-typetext.green {
                                        color: #24AE71;
                                    }
                                }

                                .text-content-name {
                                    color: #333333;
                                    font-size: 28px;
                                }

                                .text-content {
                                    margin-top: 10px;
                                }

                                .img-wrap {
                                    display: flex;
                                    flex-wrap: wrap;
                                    margin-top: 16px;

                                    .img-item {
                                        width: 160px;
                                        height: 160px;
                                        background: #F9F9FB;
                                        border-radius: 16px;
                                        margin-right: 12px;
                                        margin-bottom: 12px;

                                        &:nth-child(3n) {
                                            margin-right: 0;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.step_list {
    width: 100%;
    height: auto;
    padding-top: 0;
    overflow: hidden;
    position: relative;

    .step_item {
        padding: 0 48px 64px 140px;
        position: relative;
        z-index: 10;

        .step_icon {
            width: 64px;
            height: 64px;
            display: block;
            position: absolute;
            left: 44px;
            top: 0;
        }

        .step_info {
            padding-bottom: 20px;
        }

        .step_name {
            p:nth-child(1) {
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: $greyText;
                line-height: 34px;
            }

            p:nth-child(2) {
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: $greyText;
                line-height: 34px;
                text-align: right;
            }
        }

        .step_state {
            margin-left: auto;
            margin-top: 10px;

            p {
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: $greyText;
                line-height: 34px;
                text-align: right;
            }

            p:nth-child(1) {
                font-size: 28px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: bold;
                color: #333333;
                line-height: 40px;
            }
        }

        .step_msg {
            font-size: 24px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: $greyText;
            line-height: 34px;
        }
    }

    .step_item:nth-last-child(2) {
        background: #FFFFFF;
    }

    .them_box {
        position: relative;
        z-index: 10;
        background: #FFFFFF;
        border-radius: 0 0 16px 16px;
        font-size: 24px;
        font-family: PingFang SC-Regular, PingFang SC;
        color: #A3A3A3;
        line-height: 34px;
        border-top: 2px solid #F5F5F5;

        span {
            font-weight: bold;
            color: #3D3C4F;
        }

    }
}

.step_list::after {
    content: "";
    position: absolute;
    top: 66px;
    left: 74px;
    z-index: 0;
    width: 4px;
    height: calc(100% - 66px);
    background-image: linear-gradient(#EEEEEE 0%,
            #EEEEEE 50%,
            transparent 50%);
    background-size: 100% 16px;
    background-repeat: repeat-y;
}

.step_list_unfold {
    height: auto;
    padding-top: 66px;
}
</style>
